import { Injectable } from "@angular/core";
import { Observable, Observer, Subscription } from "rxjs";
import { TipoPratica } from "../../common/models/tipologiche/tipo-pratica";
import { FascicoliMappingService } from "../services/fascicoli-mapping.service";
import { PraticheMappingService } from "../services/pratiche-mapping.service";

@Injectable({
  providedIn: 'root'
})
export class FrontEndMapping {
  subscriptionPratiche: Subscription;
  subscriptionFascicoli: Subscription;
  tipiPratica: TipoPratica[] = [];
  listTipiPratica: any = {};
  listTipiFascicolo: any = {};

  constructor(private fascicoliMappingService: FascicoliMappingService, private praticheMappingService: PraticheMappingService) {
    this.subscriptionPratiche = this.praticheMappingService.getListTipiPraticaSubject().subscribe(list => {
        this.setListTipiPratica(this.mapListConvert(list));
    });
    this.subscriptionFascicoli = this.fascicoliMappingService.getListTipiFascicoloSubject().subscribe(list => {
        this.setListTipiFascicolo(this.mapListConvert(list));
    });
  }

  setListTipiPratica(list) {
    this.listTipiPratica = list;
  }

  getListTipiPratica(id): Observable<any> {
    if (Object.keys(this.listTipiPratica).length !== 0) {
      return  Observable.create((observer: Observer<any>) => observer.next(this.listTipiPratica[id]));
    } else {
      return Observable.create((observer: Observer<any>) => {
        this.praticheMappingService.notifyPraticheObservable.subscribe(list => {
          observer.next(this.mapListConvert(list)[id]);
        });
      });
    }
  }

  setListTipiFascicolo(list) {
    this.listTipiFascicolo = list;
  }

  getListTipiFascicolo(id) {
    if (Object.keys(this.listTipiPratica).length !== 0) {
      return  Observable.create((observer: Observer<any>) => observer.next(this.listTipiFascicolo[id]));
    } else {
      return Observable.create((observer: Observer<any>) => {
        this.fascicoliMappingService.notifyFascicoliObservable.subscribe(list => {
          observer.next(this.mapListConvert(list)[id]);
        });
      });
    }
  }

  mapListConvert(list) {
    const listTipi = {};
    list.forEach( el => {
      listTipi[el.id] = el.endpoint;
    });
    return listTipi;
  }

  // utilizzati per il routing
  public static readonly tipiPratica: { [id: string]: string } = {
    '5896d998-53e7-11ea-a08d-005056a8dd09': 'lavoro', // '1'
    '58a00511-53e7-11ea-a08d-005056a8dd09': 'civile', // '2'
    '58a65e7e-53e7-11ea-a08d-005056a8dd09': 'tributario', // '3'
    '58ac8ea5-53e7-11ea-a08d-005056a8dd09': 'amministrativa', // '4'
    '58b1c7d9-53e7-11ea-a08d-005056a8dd09': 'autoritaindipendenteregolatoria', // '5'
    '58b65f6c-53e7-11ea-a08d-005056a8dd09': 'penale', // '6'
    '58bc2192-53e7-11ea-a08d-005056a8dd09': 'pareristica' // '7'
  };
  /*public static readonly tipiFascicolo: { [id: string]: string } = {
    '1': 'ordinario',
    '2': 'cautelare',
    '3': 'esecuzioneimmobiliare',
    '4': 'esecuzionemobiliare',
    '5': 'esecuzionepressoterzi',
    '6': 'indaginipreliminari',
    '7': 'mediazione',
    '8': 'azionemonitoria',
    '9': 'precetto',
    '10': 'recuperocreditistragiudiziale',
    '11': 'parere',
    '12': 'negoziazioneassistita',
    '13': 'tentativoobbligatorioconciliazione',
    '14': '',
    '15': 'arbitrato',
    '16': 'opposizionedecretoingiuntivo',
    '17': 'opposizioneattiesecutivi',
    '18': 'opposizioneprecetto',
    '19': 'opposizioneesecuzione',
    '20': 'speciale',
    '21': '',
    '22': 'sommariourgenza',
    '23': '',
    '24': 'ricorsostraordinariopresidente',
    '25': 'ricorsogerarchico',
    '26': 'ricorsoopposizione',
    '27': 'appello',
    '28': 'revocazione',
    '29': 'opposizionediterzo',
    '30': '',
    '31': '',
    '32': 'ricorsoaltar',
    '33': 'ricorsolavoro',
    '34': 'ritofornero',
    '35': 'ricorsocassazione',
    '36': 'dibattimento',
    '37': 'ritialternativi',
    '38': '',
    '39': 'autoritaindipendentiregolatorie',
    '40': 'disciplina',
    '41': 'altrerisoluzionilavoro',
    '42': 'accessoagliatti',
    '43': 'opposaiserviziispettivi',
    '44': 'amianto',
    '45': 'amiantogiudiziale'
  };*/
}
